import React, { Component } from "react";
import ApiEndpoints from "../../../constants/api_endpoints";
import store from "../../../store";
import { setError, setLoader } from "../../../actions/action-creators";
import moment from "moment";

const fmtINR = (v) => v != null && v !== "" ? "₹" + Number(v).toLocaleString("en-IN", { minimumFractionDigits: 2 }) : "—";
const fmtDate = (v) => { const m = moment(v); return (v && m.isValid()) ? m.utcOffset("+05:30").format("Do MMM'YY, hh:mm A") : "—"; };
const fmtDateShort = (v) => { const m = moment(v); return (v && m.isValid()) ? m.utcOffset("+05:30").format("Do MMM'YY") : "—"; };

const GOAL_TYPE_MAP = {
    HEALTH:    { label: "Saving for your valuable Health",   icon: "💊" },
    BIKE:      { label: "Saving for your Dream Bike",        icon: "🏍️" },
    CAR:       { label: "Saving for your Dream Car",         icon: "🚗" },
    HOME:      { label: "Saving for your Dream Home",        icon: "🏠" },
    EDUCATION: { label: "Saving for Education",              icon: "🎓" },
    TRAVEL:    { label: "Saving for Travel",                 icon: "✈️" },
    EMERGENCY: { label: "Emergency Fund",                    icon: "🆘" },
    WEDDING:   { label: "Saving for Wedding",                icon: "💍" },
};
const CYCLE_MAP = { W: "Weekly", M: "Monthly", D: "Daily" };

const FD_STATUS = {
    INITIATED:       { label: "Initiated",       bg: "#fff7e6", color: "#d46b08" },
    PAYMENT_PENDING: { label: "Payment Pending", bg: "#fff7e6", color: "#d46b08" },
    BOOKED:          { label: "Booked",          bg: "#e6f7ee", color: "#1a7a42" },
    ACTIVE:          { label: "Active",          bg: "#e6f7ee", color: "#1a7a42" },
    MATURED:         { label: "Matured",         bg: "#e6f0ff", color: "#1a5ba8" },
    CLOSED:          { label: "Closed",          bg: "#f0f0f0", color: "#666"    },
    CANCELLED:       { label: "Cancelled",       bg: "#fff0f0", color: "#c0392b" },
    FAILED:          { label: "Failed",          bg: "#fff0f0", color: "#c0392b" },
};

const GOLD_TXN_CFG = {
    buy:           { label: "GOLD BOUGHT", bg: "#fff7e6", color: "#d46b08", icon: "🥇", sign: "+" },
    sell:          { label: "GOLD SOLD",   bg: "#fff0f0", color: "#c0392b", icon: "📤", sign: "−" },
    gift:          { label: "GOLD REWARD", bg: "#fce4ec", color: "#c2185b", icon: "🎁", sign: "+" },
    gift_received: { label: "GOLD REWARD", bg: "#fce4ec", color: "#c2185b", icon: "🎁", sign: "+" },
};

const goldTxnBadge = (type) => {
    const key = (type || "").toLowerCase();
    const cfg = GOLD_TXN_CFG[key] || { label: type || "—", bg: "#f0f0f0", color: "#555", icon: "📊" };
    return (
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <span style={{ fontSize: 15 }}>{cfg.icon}</span>
            <span style={{ background: cfg.bg, color: cfg.color, borderRadius: 999, padding: "3px 10px", fontSize: 11, fontWeight: 700, whiteSpace: "nowrap" }}>
                {cfg.label}
            </span>
        </div>
    );
};

class UserSaveGrow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            saveSubTab: "gold",
            goals: [],
            goldPortfolio: null,
            goldTransactions: [],
            fdList: [],
        };
    }

    componentDidMount() {
        this.fetchAll();
    }

    fetchAll = async () => {
        store.dispatch(setLoader(true));
        const uid = this.props.user_id;
        const [goalsRes, goldRes, goldTxnRes, fdRes] = await Promise.allSettled([
            ApiEndpoints.InvestGoal.fetchUserGoals({ user_id: uid }),
            ApiEndpoints.SafeGold.fetchUserPortfolio({ user_id: uid }),
            ApiEndpoints.SafeGold.fetchUserTransactions({ user_id: uid }),
            ApiEndpoints.InvestFD.fetchUserFDs({ user_id: uid }),
        ]);
        this.setState({
            goals:            goalsRes.status   === "fulfilled" ? goalsRes.value.data.data   || [] : [],
            goldPortfolio:    goldRes.status    === "fulfilled" ? goldRes.value.data.data    || null : null,
            goldTransactions: goldTxnRes.status === "fulfilled"
                ? Array.isArray(goldTxnRes.value.data.data) ? goldTxnRes.value.data.data : []
                : [],
            fdList:           fdRes.status      === "fulfilled" ? fdRes.value.data.data      || [] : [],
        });
        store.dispatch(setLoader(false));
    };

    renderGoals() {
        const { goals, goldPortfolio } = this.state;
        if (!goals.length) {
            return (
                <div style={S.goalEmptyCard}>
                    <span style={{ fontSize: 28, marginBottom: 8, display: "block" }}>🎯</span>
                    <div style={{ fontWeight: 700, color: "#c0392b", fontSize: 14, marginBottom: 4 }}>No Savings Goal Set</div>
                    <div style={{ fontSize: 12, color: "#aaa" }}>This partner has not configured any savings goal yet.</div>
                </div>
            );
        }
        const currentValue = Number(
            goldPortfolio?.total_locked_amount ??
            goldPortfolio?.current_value ??
            goldPortfolio?.total_saved_amount ??
            0
        );
        return goals.map((goal, i) => {
            const cfg = GOAL_TYPE_MAP[goal.goal_type] || { label: goal.goal_type, icon: "🎯" };
            const progress = goal.goal_amount
                ? Math.min((currentValue / Number(goal.goal_amount)) * 100, 100)
                : 0;
            return (
                <div key={i} style={S.goalCard}>
                    <div style={S.goalBadge}><span style={{ marginRight: 5 }}>🎯</span> Goal Active</div>
                    <div style={S.goalTitle}>{cfg.label} {cfg.icon}</div>
                    <div style={S.goalMeta}>
                        {fmtINR(goal.goal_amount)} in {goal.goal_tenure} Months
                        {goal.target_amount
                            ? ` • ${fmtINR(goal.target_amount)}/${CYCLE_MAP[goal.target_cycle] || goal.target_cycle}`
                            : ""}
                    </div>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: 8 }}>
                        <div style={S.goalSavings}>Current Savings — {fmtINR(currentValue)}</div>
                        <div style={S.progressPct}>{progress.toFixed(1)}%</div>
                    </div>
                    <div style={S.progressBar}>
                        <div style={{ ...S.progressFill, width: progress + "%" }} />
                    </div>
                </div>
            );
        });
    }

    renderGoldSummary() {
        const { goldPortfolio: p } = this.state;
        const grams    = p?.gold_balance      ?? null;
        const invested = p?.total_invested    ?? p?.total_saved_amount ?? null;
        return (
            <div style={S.goldSummaryCard}>
                <div style={S.summaryLabel}>DIGITAL GOLD SUMMARY</div>
                <div style={S.summaryKpis}>
                    <div>
                        <div style={S.summaryKpiLabel}>Current Gold Holding</div>
                        <div style={{ ...S.summaryKpiValue, color: "#b8860b" }}>
                            {grams != null ? Number(grams).toFixed(4) + " g" : "—"}
                        </div>
                    </div>
                    <div>
                        <div style={S.summaryKpiLabel}>Invested Amount</div>
                        <div style={{ ...S.summaryKpiValue, color: "#b8860b" }}>{fmtINR(invested)}</div>
                    </div>
                </div>
            </div>
        );
    }

    renderGoldTransactions() {
        const { goldTransactions } = this.state;
        if (!goldTransactions.length) {
            return <div style={S.empty}>No gold transactions found.</div>;
        }
        return (
            <div style={S.tableWrapper}>
                <table style={S.table}>
                    <thead>
                        <tr style={S.tHead}>
                            <th style={S.th}>Type</th>
                            <th style={S.th}>Amount</th>
                            <th style={S.th}>Quantity (g)</th>
                            <th style={S.th}>Status</th>
                            <th style={S.th}>Source / Remark</th>
                            <th style={S.th}>Reference ID</th>
                            <th style={{ ...S.th, textAlign: "right" }}>Date & Time</th>
                        </tr>
                    </thead>
                    <tbody>
                        {goldTransactions.map((txn, i) => {
                            const key   = (txn.transaction_type || txn.type || "").toLowerCase();
                            const cfg   = GOLD_TXN_CFG[key] || { sign: "", color: "#555" };
                            const grams  = txn.gold_amount ?? txn.grams ?? null;
                            const amount = txn.buy_price ?? txn.sell_price ?? txn.amount ?? null;
                            const refId  = txn.invoice_no ?? txn.tx_id ?? txn.transaction_id ?? txn.id ?? null;
                            const date   = txn.created_at ?? txn.transaction_date ?? txn.date ?? txn.created_on ?? null;
                            const status = txn.status ?? txn.transaction_status ?? null;
                            return (
                                <tr key={i} style={S.tRow}>
                                    <td style={S.td}>{goldTxnBadge(txn.transaction_type || txn.type)}</td>
                                    <td style={{ ...S.td, fontWeight: 700, color: cfg.sign === "+" ? "#1a7a42" : "#c0392b" }}>
                                        {cfg.sign}{fmtINR(amount)}
                                    </td>
                                    <td style={S.td}>{grams != null ? Number(grams).toFixed(4) + " g" : "—"}</td>
                                    <td style={S.td}>
                                        {status
                                            ? <span style={{ fontSize: 11, fontWeight: 700, color: "#1a7a42" }}>{status.toString().toUpperCase().replace(/_/g, " ")}</span>
                                            : <span style={{ color: "#bbb" }}>—</span>
                                        }
                                    </td>
                                    <td style={{ ...S.td, color: "#666", fontSize: 12 }}>
                                        {txn.description || txn.remarks || "—"}
                                    </td>
                                    <td style={{ ...S.td, fontSize: 12, color: "#888", fontFamily: "monospace" }}>
                                        {refId ?? "—"}
                                    </td>
                                    <td style={{ ...S.td, textAlign: "right", fontSize: 12, color: "#888", whiteSpace: "nowrap" }}>
                                        {fmtDate(date)}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    }

    renderFDSummary() {
        const { fdList } = this.state;
        const activeFDs = fdList.filter(fd => ["BOOKED", "ACTIVE"].includes(fd.fd_status));
        const invested  = fdList.reduce((s, fd) => s + Number(fd.investment_amount || 0), 0);
        const maturity  = fdList.reduce((s, fd) => s + Number(fd.maturity_amount   || 0), 0);
        return (
            <div style={S.fdSummaryCard}>
                <div style={S.summaryLabel}>FIXED DEPOSIT SUMMARY</div>
                <div style={S.summaryKpis}>
                    <div>
                        <div style={S.summaryKpiLabel}>Invested Amount</div>
                        <div style={{ ...S.summaryKpiValue, color: "#888" }}>{fmtINR(invested)}</div>
                    </div>
                    <div>
                        <div style={S.summaryKpiLabel}>Maturity Amount</div>
                        <div style={{ ...S.summaryKpiValue, color: "#888" }}>{fmtINR(maturity)}</div>
                    </div>
                    <div>
                        <div style={S.summaryKpiLabel}>Active FDs</div>
                        <div style={{ ...S.summaryKpiValue, color: "#888" }}>{activeFDs.length}</div>
                    </div>
                </div>
            </div>
        );
    }

    renderFDList() {
        const { fdList } = this.state;
        if (!fdList.length) {
            return (
                <div style={S.fdEmpty}>
                    <div style={{ fontSize: 48, marginBottom: 10 }}>📁</div>
                    <div style={{ color: "#999", fontSize: 14 }}>No Fixed Deposit history found for this partner.</div>
                </div>
            );
        }
        return (
            <div style={S.tableWrapper}>
                <table style={S.table}>
                    <thead>
                        <tr style={S.tHead}>
                            <th style={S.th}>Provider</th>
                            <th style={S.th}>Invested</th>
                            <th style={S.th}>Maturity Amount</th>
                            <th style={S.th}>Rate</th>
                            <th style={S.th}>Tenure</th>
                            <th style={S.th}>Maturity Date</th>
                            <th style={S.th}>Status</th>
                            <th style={{ ...S.th, textAlign: "right" }}>Booked On</th>
                        </tr>
                    </thead>
                    <tbody>
                        {fdList.map((fd, i) => {
                            const cfg = FD_STATUS[fd.fd_status] || { label: fd.fd_status || "—", bg: "#f0f0f0", color: "#666" };
                            return (
                                <tr key={i} style={S.tRow}>
                                    <td style={{ ...S.td, fontWeight: 600 }}>{fd.provider_name || "—"}</td>
                                    <td style={{ ...S.td, fontWeight: 700 }}>{fmtINR(fd.investment_amount)}</td>
                                    <td style={{ ...S.td, fontWeight: 700, color: "#1a7a42" }}>{fmtINR(fd.maturity_amount)}</td>
                                    <td style={S.td}>{fd.interest_rate ? fd.interest_rate + "%" : "—"}</td>
                                    <td style={S.td}>{fd.tenure_in_months ? fd.tenure_in_months + " mo" : "—"}</td>
                                    <td style={{ ...S.td, whiteSpace: "nowrap", color: "#555" }}>{fmtDateShort(fd.maturity_date)}</td>
                                    <td style={S.td}>
                                        <span style={{ background: cfg.bg, color: cfg.color, borderRadius: 999, padding: "3px 10px", fontSize: 11, fontWeight: 700, whiteSpace: "nowrap" }}>
                                            {cfg.label}
                                        </span>
                                    </td>
                                    <td style={{ ...S.td, textAlign: "right", fontSize: 12, color: "#888", whiteSpace: "nowrap" }}>
                                        {fmtDateShort(fd.booked_date)}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    }

    render() {
        const { saveSubTab } = this.state;
        return (
            <div>
                {this.renderGoals()}

                <div style={S.subTabRow}>
                    {[{ key: "gold", label: "🥇 Digital Gold" }, { key: "fd", label: "🏦 Fixed Deposit" }].map(t => (
                        <button
                            key={t.key}
                            style={{ ...S.subTab, ...(saveSubTab === t.key ? S.subTabActive : {}) }}
                            onClick={() => this.setState({ saveSubTab: t.key })}
                        >
                            {t.label}
                        </button>
                    ))}
                </div>

                {saveSubTab === "gold" && (
                    <div>
                        {this.renderGoldSummary()}
                        <div style={{ ...S.sectionTitle, marginTop: 20 }}>Gold Transaction History</div>
                        {this.renderGoldTransactions()}
                    </div>
                )}

                {saveSubTab === "fd" && (
                    <div>
                        {this.renderFDSummary()}
                        <div style={{ ...S.sectionTitle, marginTop: 20 }}>Fixed Deposit Bookings</div>
                        {this.renderFDList()}
                    </div>
                )}
            </div>
        );
    }
}

const S = {
    goalEmptyCard: {
        background: "#fff5f5",
        border: "1.5px dashed #f5c6c6",
        borderRadius: 16,
        padding: "22px",
        marginBottom: 20,
        textAlign: "center",
    },
    goalCard: {
        background: "#fff5f5",
        border: "1.5px solid #f5c6c6",
        borderRadius: 16,
        padding: "18px 22px",
        marginBottom: 20,
    },
    goalBadge: {
        display: "inline-flex",
        alignItems: "center",
        background: "#ffe8e8",
        color: "#c0392b",
        borderRadius: 999,
        padding: "4px 12px",
        fontSize: 12,
        fontWeight: 700,
        marginBottom: 12,
    },
    goalTitle:   { fontSize: 18, fontWeight: 800, color: "#1a1a1a", marginBottom: 6 },
    goalMeta:    { fontSize: 14, color: "#c0392b" },
    goalSavings: { fontSize: 13, color: "#c0392b" },
    progressBar: { height: 6, borderRadius: 999, background: "#f5c6c6", overflow: "hidden", marginTop: 8 },
    progressFill:{ height: "100%", borderRadius: 999, background: "#c0392b", transition: "width 0.3s ease" },
    progressPct: { fontSize: 12, fontWeight: 700, color: "#c0392b" },

    subTabRow:   { display: "flex", gap: 0, marginBottom: 24, border: "1.5px solid #e0e0e0", borderRadius: 10, overflow: "hidden", width: "fit-content" },
    subTab:      { padding: "10px 24px", fontWeight: 600, fontSize: 13, border: "none", cursor: "pointer", background: "#fff", color: "#555", outline: "none" },
    subTabActive:{ background: "#1677ff", color: "#fff" },

    goldSummaryCard: { background: "#fffbf0", border: "1px solid #f0e0a0", borderRadius: 14, padding: "18px 22px", marginBottom: 4 },
    fdSummaryCard:   { background: "#f0f5ff", border: "1px solid #bfd8f7", borderRadius: 14, padding: "18px 22px", marginBottom: 4 },
    summaryLabel:    { fontSize: 11, fontWeight: 700, color: "#999", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 16 },
    summaryKpis:     { display: "flex", gap: 40, flexWrap: "wrap" },
    summaryKpiLabel: { fontSize: 12, color: "#888", marginBottom: 4 },
    summaryKpiValue: { fontSize: 22, fontWeight: 800, color: "#1a1a1a" },

    sectionTitle: { fontSize: 14, fontWeight: 700, color: "#1a1a1a", marginBottom: 12 },

    tableWrapper: { border: "1px solid #e8e8e8", borderRadius: 10, overflowX: "auto" },
    table:  { width: "100%", borderCollapse: "collapse", fontSize: 13 },
    tHead:  { background: "#f5f5f5" },
    th:     { padding: "10px 14px", textAlign: "left", fontWeight: 600, color: "#555", borderBottom: "1px solid #e8e8e8", whiteSpace: "nowrap" },
    tRow:   { borderBottom: "1px solid #f0f0f0" },
    td:     { padding: "11px 14px", color: "#333", verticalAlign: "middle" },

    empty:   { padding: "40px 20px", textAlign: "center", color: "#aaa", fontSize: 14 },
    fdEmpty: { padding: "60px 20px", textAlign: "center" },
};

export default UserSaveGrow;
